import {
    AdBannerBottom, AdChatListItem, AdFeedNative, AdProfileBottom,
} from './AdInlineFormats';
import useAdSlot from './useAdSlot';


const RENDERERS = {
    banner_bottom: AdBannerBottom,
    feed_native: AdFeedNative,
    chat_list: AdChatListItem,
    profile_bottom: AdProfileBottom,
    search_inline: AdFeedNative,
};


/**
 * Готовый к вставке рекламный блок.
 *
 *   <AdSlot placement="banner_bottom" />
 *
 * Ничего не рендерит, если объявления нет, площадка выключена, реклама
 * отключена глобально или запрос не удался. Заглушки «здесь могла быть
 * ваша реклама» не рисуем — пустое место лучше, чем признание, что
 * инвентарь не продан.
 *
 * Полноэкранные форматы сюда не входят: их показ привязан к моменту
 * (возврат в приложение, нажатие кнопки), а не к месту на экране.
 */
export default function AdSlot({ placement, enabled = true, deps = [] }) {
    const { ad } = useAdSlot(placement, { enabled, deps });

    if (!ad) return null;

    const Renderer = RENDERERS[ad.format] || RENDERERS[placement];
    if (!Renderer) return null;

    return <Renderer key={ad.token} ad={ad} />;
}